module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/snowboarding@2x_d3cb7a.jpg";